import React, { Component } from 'react';
import { Container, Card, Row, Col, Button, ButtonGroup, DropdownButton, Dropdown, Form, Spinner, Table, Modal, Badge, Tabs, Tab, Nav } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { GET, POST } from '../../api';
import Pagination from '../_partials/Pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheck, faClock, faEye, faEyeSlash, faFileExcel, faFileLines, faFolder, faGlobe, faImage, faList, faNewspaper, faPencil, faPlus, faSave, faSearch, faTrash, faTrashCan, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { renderTableBody, renderTableHead } from '../../helpers/table_helper';
import { toast } from 'react-toastify';
import { handleFormErrors } from '../../helpers/form_helpers';
import moment from 'moment/moment';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import SweetAlert from 'react-bootstrap-sweetalert';
import GetIcon from '../../helpers/icon_helper';
import { Concrete, Lotion, Taurus, White, RedLustre, OrangeRYB, Black, CyanProcess, BlueCrayola, SunsetOrange, SpanishGray, SoftGray, SilentPink, NewGray, WhiteMarble } from '../../helpers/brand_colors_helper';
import { changeColorOpacity, makeURL } from '../../helpers/general_helpers';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';

var Chance = require('chance');
var chance = new Chance();

class CAS extends Component {

  docRef = React.createRef();

  defaultFormFields = {
    ib_cas_id: 0,
    ib_cas_name: '',
    ib_cas_description: '',
    ib_cas_startdate: '',
    ib_cas_enddate: '',
    ib_cas_iscasproject: 0,
    ib_cas_strands: [],
    ib_cas_approaches: [],
    ib_cas_service_actions: null,
    ib_cas_supervisors: [],
    ib_cas_target_outcome: [],
  };

  defaultReflectionFields = {
    ib_cas_ref_id: 0,
    ib_cas_ref_title: '',
    ib_cas_ref_desc: '',
    ib_cas_ref_date: new Date(),
    ib_cas_ref_target_outcome: [],
    ib_cas_id: 0,
    details: [],
  };

  defaultReflectionDetailFields = {
    ib_cas_refd_id: 0,
    ib_cas_refd_type: '',//URL', 'Image', 'File
    ib_cas_refd_value: '',
    ib_cas_refd_name: ''
  };

  experience_status_options = [
    { label: 'To Be Determined', value: 'To Be Determined', backgroundColor: changeColorOpacity(OrangeRYB, 0.15), color: OrangeRYB },
    { label: 'Approved', value: 'Approved', backgroundColor: changeColorOpacity(CyanProcess, 0.15), color: CyanProcess },
    { label: 'Completed', value: 'Completed', backgroundColor: changeColorOpacity(BlueCrayola, 0.15), color: BlueCrayola },
    { label: 'Rejected', value: 'Rejected', backgroundColor: changeColorOpacity(SunsetOrange, 0.15), color: SunsetOrange },
    // 'To Be Determined',
    // 'Approved',
    // 'Completed',
    // 'Rejected'
  ];

  progress_options = [
    { label: 'To Be Determined', value: 'To Be Determined', backgroundColor: changeColorOpacity(OrangeRYB, 0.15), color: OrangeRYB },
    { label: 'Concern', value: 'Concern', backgroundColor: changeColorOpacity(CyanProcess, 0.15), color: CyanProcess },
    { label: 'On Track', value: 'On Track', backgroundColor: changeColorOpacity(BlueCrayola, 0.15), color: BlueCrayola },
    { label: 'Excellent', value: 'Excellent', backgroundColor: changeColorOpacity(SunsetOrange, 0.15), color: SunsetOrange },
    // 'To Be Determined',
    // 'Concern',
    // 'On Track',
    // 'Excellent'
  ];

  state = {
    ...this.defaultFormFields,
    showFormModal: false,
    reflectionListModal: {
      show: false,
      data: null
    },
    showReflectionModal: {
      show: false,
      toggleModal: () => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, show: !this.state.showReflectionModal.show, viewStyle: 'tab' } }),
      viewStyle: 'tab'//tab, timeline
    },
    supervisors: [],
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'cas.ib_cas_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'cas.ib_cas_id',
          column: 'ib_cas_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'cas.ib_cas_iscasproject',
          column: 'ib_cas_iscasproject',
          name: 'CAS Project',
          visibility: true,
          sortable: true,
        },
        {
          id: 'cas.ib_cas_experience_status',
          column: 'ib_cas_experience_status',
          name: 'Experience Status',
          visibility: true,
          sortable: true,
        },
        {
          id: 'cas.ib_cas_name',
          column: 'ib_cas_name',
          name: 'Experience Name',
          visibility: true,
          sortable: true,
        },
        {
          id: 'cas.ib_cas_strands',
          column: 'ib_cas_strands',
          name: 'CAS',
          visibility: true,
          sortable: true,
        },
        {
          id: 'cas.ib_cas_progress',
          column: 'ib_cas_progress',
          name: 'Progress',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    refcdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'casref.ib_cas_ref_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        // {
        //   id: 'casref.ib_cas_ref_id',
        //   column: 'ib_cas_ref_id',
        //   name: 'Actions',
        //   visibility: true,
        //   sortable: true,
        // },
        {
          id: 'casref.ib_cas_ref_title',
          column: 'ib_cas_ref_title',
          name: 'Reflection Title',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    docscdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'casdocs.ib_cas_doc_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'casdocs.ib_cas_doc_id',
          column: 'ib_cas_doc_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'casdocs.ib_cas_doc_caption',
          column: 'ib_cas_doc_caption',
          name: 'Document',
          visibility: true,
          sortable: true,
        },
        {
          id: 'casdocs.ib_cas_doc_date',
          column: 'ib_cas_doc_date',
          name: 'Date',
          visibility: true,
          sortable: true,
        },
        {
          id: 'casdocs.created_on',
          column: 'created_on',
          name: 'Created Date',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    notescdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'casnotes.ib_cas_note_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'casnotes.ib_cas_note_id',
          column: 'ib_cas_note_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'casnotes.ib_cas_note',
          column: 'ib_cas_note',
          name: 'Note',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },

    // Reflection modal and form
    addReflectionModal: {
      show: false,
      working: false,
      isEditing: false,
      toggle: (addReflectionForm = { ...this.defaultReflectionFields }, isEditing = false) => {
        this.setState({
          addReflectionModal: { ...this.state.addReflectionModal, show: !this.state.addReflectionModal.show, working: false, isEditing },
          addReflectionForm
        })
      },
    },
    addReflectionForm: { ...this.defaultReflectionFields },
    activeTab: 'documents',
    showDocumentModal: false,
    editDocumentModal: false,
    ib_cas_doc_id: 0,
    ib_cas_doc_caption: '',
    ib_cas_doc_name: '',
    ib_cas_doc_date: new Date(),
    CASDocWorking: false,
    ib_cas_note_id: 0,
    ib_cas_note: '',
    showNoteModal: false,
    editNoteModal: false,
    CASNoteWorking: false,
    deleteRefDetailConfirm: {
      show: false,
      id: 0,
    },
    getTimelineData: {
      fetching: false,
      search: '',
      data: []
    },
  }

  componentDidMount() {
    const { search, rows: limit, order, dir } = this.state.cdt;
    this.fetch({
      search,
      limit,
      order,
      dir,
      page: 0,
    });
    this.getSupervisors();
  }

  fetch = async (params) => {
    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      },
    });

    if (this.fetchReq) {
      this.fetchReq.abort();
    }
    this.fetchReq = new AbortController();

    try {
      const res = await GET('cas/get', {
        signal: this.fetchReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
        },
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      // console.log('err', err);
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        },
      });
    }
  };

  getSupervisors = async () => {
    if (this.getSupervisorsReq) {
      this.getSupervisorsReq.abort();
    }
    this.getSupervisorsReq = new AbortController();
    const res = await GET('cas/get-supervisors', {
      signal: this.getSupervisorsReq.signal,
      params: {
        class_id: this.props.selectedChild.class_id
      },
    });
    if (res) {
      this.setState({
        supervisors: res.data.map((v, i) => { return { ...v, label: v.full_name, value: v.user_id } }
        )
      })
    }

  }

  handleOpenFormModal = () => {
    this.setState({
      showFormModal: true,
    });
  };

  handleCloseFormModal = () => {
    this.setState({
      showFormModal: false,
      isEditing: false,
      ...this.defaultFormFields,
    });
  };

  handleCloseReflectionListModal = () => {
    this.setState({
      showReflectionModal: { ...this.state.showReflectionModal, show: false, viewStyle: 'tab' }
    });
  };

  showHideColumn = (column_index) => {
    const columns = this.state.cdt.columns;
    columns[column_index].visibility = !columns[column_index].visibility;
    this.setState({ ctd: { ...this.state.ctd, columns } });
  };

  handleStrandClick = (strand) => {
    this.setState((prevState) => {
      const { ib_cas_strands } = prevState;
      if (ib_cas_strands.includes(strand)) {
        return { ib_cas_strands: ib_cas_strands.filter((item) => item !== strand) };
      } else {
        return { ib_cas_strands: [...ib_cas_strands, strand] };
      }
    });
  };

  exportExcel = async () => {
    const excelData = this.state.cdt.data.map((item) => {
      const row = {};
      this.state.cdt.columns
        .filter((column) => column.visibility)
        .map((column) => {
          if (column.name !== 'Actions') {
            row[column.name] = item[column.column];
          }
        });
      return row;
    });

    const fileName =
      'Communication Source Export ' + moment().format('DD-MM-YYYY');
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  saveUpdate = async () => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;

    const {
      ib_cas_id,
      ib_cas_name,
      ib_cas_description,
      ib_cas_startdate,
      ib_cas_enddate,
      ib_cas_iscasproject,
      ib_cas_strands,
      ib_cas_approaches,
      ib_cas_service_actions,
      ib_cas_supervisors,
      ib_cas_target_outcome,
    } = this.state;

    if (ib_cas_strands.length <= 1) {
      toast.warning(t('Please pick at-least 2 Strand!'));
      return
    }

    this.setState({ working: true });
    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append(
      'casData',
      JSON.stringify({
        ib_cas_id,
        ib_cas_name,
        ib_cas_description,
        ib_cas_startdate: (ib_cas_startdate) ? moment(ib_cas_startdate).format('YYYY-MM-DD') : null,
        ib_cas_enddate: (ib_cas_enddate) ? moment(ib_cas_enddate).format('YYYY-MM-DD') : null,
        ib_cas_iscasproject,
        ib_cas_strands: JSON.stringify(ib_cas_strands),
        ib_cas_approaches: JSON.stringify(ib_cas_approaches),
        ib_cas_service_actions,
        ib_cas_supervisors: JSON.stringify(ib_cas_supervisors.map((v) => v.value)),
        ib_cas_target_outcome: JSON.stringify(ib_cas_target_outcome)
      })
    );

    try {
      const res = await POST('cas/save', fData);
      if (res.data.type) {
        this.setState({ working: false });
        toast.success(t(res.data.message));
        this.fetch({
          search: '',
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: 0,
        });
        this.handleCloseFormModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ working: false });
      }
    } catch (err) {
      // console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  };

  edit = (data) => {
    // console.log('data', data);
    const supervisors = JSON.parse(data.ib_cas_supervisors).map((v, i) => {
      return {
        label: this.state.supervisors.find((supervisor) => supervisor.value == v).label,
        value: v
      }
    });
    this.setState({
      isEditing: true,
      ib_cas_id: data.ib_cas_id,
      ib_cas_name: data.ib_cas_name,
      ib_cas_description: data.ib_cas_description,
      ib_cas_startdate: (data.ib_cas_startdate) ? new Date(data.ib_cas_startdate) : null,
      ib_cas_enddate: (data.ib_cas_enddate) ? new Date(data.ib_cas_enddate) : null,
      ib_cas_iscasproject: data.ib_cas_iscasproject,
      ib_cas_strands: JSON.parse(data.ib_cas_strands),
      ib_cas_approaches: JSON.parse(data.ib_cas_approaches),
      ib_cas_service_actions: data.ib_cas_service_actions,
      ib_cas_supervisors: supervisors,
      ib_cas_target_outcome: JSON.parse(data.ib_cas_target_outcome),
      showFormModal: true,
    });
  };

  handleCheckbox = (event, stateKey) => {
    const { value, checked } = event.target;

    this.setState((prevState) => {
      let updatedState = [...prevState[stateKey]];
      if (checked) {
        if (!updatedState.includes(value)) {
          updatedState.push(value);
        }
      } else {
        updatedState = updatedState.filter((item) => item !== value);
      }
      return { [stateKey]: updatedState };
    });
  };

  handleReflectionOutcomeCheckbox = (event) => {
    const { value, checked } = event.target;

    this.setState((prevState) => {
      let updatedState = [...prevState['addReflectionForm']['ib_cas_ref_target_outcome']];
      if (checked) {
        if (!updatedState.includes(value)) {
          updatedState.push(value);
        }
      } else {
        updatedState = updatedState.filter((item) => item !== value);
      }
      return {
        addReflectionForm: {
          ...this.state.addReflectionForm,
          ib_cas_ref_target_outcome: updatedState
        }
      };
    });
  };

  CASView = (data) => {

    const supervisors = JSON.parse(data.ib_cas_supervisors).map((v, i) => {
      return {
        label: this.state.supervisors.find((supervisor) => supervisor.value == v).label,
        value: v
      }
    });

    let selectedExperience = this.experience_status_options.find((v) => v.value == data.ib_cas_experience_status)
    let selectedProgress = this.progress_options.find((v) => v.value == data.ib_cas_progress)

    this.setState({
      showReflectionModal: { ...this.state.showReflectionModal, show: true, },
      isEditing: true,
      ib_cas_id: data.ib_cas_id,
      ib_cas_name: data.ib_cas_name,
      ib_cas_description: data.ib_cas_description,
      ib_cas_startdate: (data.ib_cas_startdate) ? new Date(data.ib_cas_startdate) : null,
      ib_cas_enddate: (data.ib_cas_enddate) ? new Date(data.ib_cas_enddate) : null,
      ib_cas_iscasproject: data.ib_cas_iscasproject,
      ib_cas_strands: JSON.parse(data.ib_cas_strands),
      ib_cas_approaches: JSON.parse(data.ib_cas_approaches),
      ib_cas_service_actions: data.ib_cas_service_actions,
      ib_cas_supervisors: supervisors,
      ib_cas_target_outcome: JSON.parse(data.ib_cas_target_outcome),
      ib_cas_supervisor_review: data.ib_cas_supervisor_review,
      ib_cas_experience_status: selectedExperience,
      ib_cas_progress: selectedProgress,
    }, () => {
      this.getReflections({
        search: '',
        limit: this.state.refcdt.rows,
        order: this.state.refcdt.order,
        dir: this.state.refcdt.dir,
        page: 0,
      });
      this.getDocs({
        search: '',
        limit: this.state.docscdt.rows,
        order: this.state.docscdt.order,
        dir: this.state.docscdt.dir,
        page: 0,
      });
      this.getNotes({
        search: '',
        limit: this.state.notescdt.rows,
        order: this.state.notescdt.order,
        dir: this.state.notescdt.dir,
        page: 0,
      });
    });
  }

  getReflections = async (params) => {
    this.setState({
      refcdt: {
        ...this.state.refcdt,
        fetching: true,
      },
    });

    if (this.getReflectionsReq) {
      this.getReflectionsReq.abort();
    }
    this.getReflectionsReq = new AbortController();

    try {
      const res = await GET('cas/get-reflections', {
        signal: this.getReflectionsReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_cas_id: this.state.ib_cas_id,
          parent_ib_cas_ref_id: (params.parent_ib_cas_ref_id) ? params.parent_ib_cas_ref_id : null
        },
      });

      // console.log('res', res);

      if (res.status === 200) {
        this.setState({
          refcdt: {
            ...this.state.refcdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      // console.log('err', err);
      this.setState({
        refcdt: {
          ...this.state.refcdt,
          fetching: false,
        },
      });
    }
  };

  editReflection = (data) => {
    let ib_cas_ref_target_outcome = [];
    if (data.ib_cas_ref_target_outcome) {
      ib_cas_ref_target_outcome = JSON.parse(data.ib_cas_ref_target_outcome);
    }
    this.state.addReflectionModal.toggle({
      ...data,
      ib_cas_ref_date: new Date(data.ib_cas_ref_date),
      ib_cas_ref_target_outcome,
      details: []
    }, true)
  }

  setReflectionValue = (column, value) => {
    let { addReflectionForm } = this.state
    addReflectionForm[column] = value
    this.setState({ addReflectionForm })
  }

  addReflectionDetail = (ib_cas_refd_type) => {
    let { addReflectionForm } = this.state
    addReflectionForm['details'].push({ ...this.defaultReflectionDetailFields, ib_cas_refd_type })
    this.setState({ addReflectionForm })
  }

  delRefDetail = async () => {
    const { id } = this.state.deleteRefDetailConfirm;

    try {
      const res = await GET('cas/delete-reflection-detail', {
        params: {
          ib_cas_refd_id: id,
        },
      });
      this.getReflections({
        search: this.state.refcdt.search,
        limit: this.state.refcdt.rows,
        order: this.state.refcdt.order,
        dir: this.state.refcdt.dir,
        page: this.state.refcdt.page,
      });
      this.setState({ deleteRefDetailConfirm: { show: false, id: 0 } });
      toast.success(t(res.data.message));
    } catch (err) {
      // console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  setReflectionDetailValue = (index, column, value) => {
    let { addReflectionForm } = this.state
    addReflectionForm['details'][index][column] = value
    this.setState({ addReflectionForm })
  };

  saveUpdateReflection = async () => {
    let { addReflectionForm, addReflectionModal } = this.state;
    addReflectionForm = { ...addReflectionForm }
    this.setState({ addReflectionModal: { ...addReflectionModal, working: true } });
    addReflectionForm.ib_cas_ref_date = moment(addReflectionForm.ib_cas_ref_date).format('YYYY-MM-DD')

    const fData = new FormData();
    addReflectionForm.details = addReflectionForm.details.map((v, i) => {
      if ((v.ib_cas_refd_type == 'File' || v.ib_cas_refd_type == 'Image') && v.ib_cas_refd_value?.name) {
        fData.append('reflectionFiles[' + i + ']', v.ib_cas_refd_value);
      }
      return { ...v }
    })
    fData.append('addReflectionForm', JSON.stringify(addReflectionForm));
    fData.append('child_user_id', this.props.selectedChild.child_user_id);

    try {
      const res = await POST('cas/save-reflection', fData);
      if (res.data.type) {
        addReflectionModal.toggle()
        toast.success(t(res.data.message));
        this.getReflections({
          search: '',
          limit: this.state.refcdt.rows,
          order: this.state.refcdt.order,
          dir: this.state.refcdt.dir,
          page: 0,
        });
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ working: false });
      }
    } catch (err) {
      // console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  }

  handleCloseDocumentModal = () => {
    this.setState({
      showDocumentModal: false,
      editDocumentModal: false,
      ib_cas_doc_id: 0,
      ib_cas_doc_caption: '',
      ib_cas_doc_name: '',
      ib_cas_doc_date: new Date(),
    });
  }

  saveUpdateCASDoc = async () => {
    const { ib_cas_id, ib_cas_doc_id, ib_cas_doc_caption, ib_cas_doc_name, ib_cas_doc_date, editDocumentModal } = this.state;

    if (!ib_cas_doc_caption) {
      toast.error(t('Please enter document caption'));
      return;
    }

    if (!editDocumentModal && !ib_cas_doc_name) {
      toast.error(t('Please select a file'));
      return;
    }

    this.setState({ CASDocWorking: true });

    const fData = new FormData();
    fData.append('ib_cas_doc_id', ib_cas_doc_id);
    fData.append('ib_cas_doc_caption', ib_cas_doc_caption);
    fData.append('ib_cas_doc_name', ib_cas_doc_name);
    fData.append('ib_cas_doc_date', (ib_cas_doc_date) ? moment(ib_cas_doc_date).format('YYYY-MM-DD') : '');
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append('ib_cas_id', ib_cas_id);

    try {
      const res = await POST('cas/save-cas-doc', fData);
      if (res.data.type) {
        this.setState({ CASDocWorking: false });
        toast.success(t(res.data.message));
        this.getDocs({
          search: '',
          limit: this.state.docscdt.rows,
          order: this.state.docscdt.order,
          dir: this.state.docscdt.dir,
          page: 0,
        });
        this.handleCloseDocumentModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ CASDocWorking: false });
      }
    } catch (err) {
      // console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ CASDocWorking: false });
    }
  }

  getDocs = async (params) => {
    this.setState({
      docscdt: {
        ...this.state.docscdt,
        fetching: true,
      },
    });

    if (this.getDocsReq) {
      this.getDocsReq.abort();
    }
    this.getDocsReq = new AbortController();

    try {
      const res = await GET('cas/get-documents', {
        signal: this.getDocsReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_cas_id: this.state.ib_cas_id
        },
      });

      if (res.status === 200) {
        this.setState({
          docscdt: {
            ...this.state.docscdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      // console.log('err', err);
      this.setState({
        docscdt: {
          ...this.state.docscdt,
          fetching: false,
        },
      });
    }
  };

  editDoc = (data) => {
    this.setState({
      showDocumentModal: true,
      editDocumentModal: true,
      ib_cas_doc_caption: data.ib_cas_doc_caption,
      ib_cas_doc_date: new Date(data.ib_cas_doc_date),
      ib_cas_doc_id: data.ib_cas_doc_id,
    });
  };

  deleteDoc = async (data) => {
    try {
      const res = await GET('cas/delete-doc', {
        params: {
          ib_cas_doc_id: data.ib_cas_doc_id,
        },
      });
      this.setState({
        docscdt: {
          ...this.state.docscdt,
          data: this.state.docscdt.data.filter((item) => item.uid !== data.uid),
        },
      });
      toast.success(t(res.data.message));
    } catch (err) {
      // console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  getNotes = async (params) => {
    this.setState({
      notescdt: {
        ...this.state.notescdt,
        fetching: true,
      },
    });

    if (this.getNotesReq) {
      this.getNotesReq.abort();
    }
    this.getNotesReq = new AbortController();

    try {
      const res = await GET('cas/get-notes', {
        signal: this.getNotesReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_cas_id: this.state.ib_cas_id
        },
      });

      if (res.status === 200) {
        this.setState({
          notescdt: {
            ...this.state.notescdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      // console.log('err', err);
      this.setState({
        notescdt: {
          ...this.state.notescdt,
          fetching: false,
        },
      });
    }
  };

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      editNoteModal: false,
      ib_cas_note_id: 0,
      ib_cas_note: ''
    });
  }

  saveUpdateCASNote = async () => {
    const { ib_cas_id, ib_cas_note_id, ib_cas_note } = this.state;

    if (!ib_cas_note) {
      toast.error(t('Please enter note'));
      return;
    }


    this.setState({ CASNoteWorking: true });

    const fData = new FormData();
    fData.append('ib_cas_note_id', ib_cas_note_id);
    fData.append('ib_cas_note', ib_cas_note);
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append('ib_cas_id', ib_cas_id);

    try {
      const res = await POST('cas/save-cas-note', fData);
      if (res.data.type) {
        this.setState({ CASNoteWorking: false });
        toast.success(t(res.data.message));
        this.getNotes({
          search: '',
          limit: this.state.notescdt.rows,
          order: this.state.notescdt.order,
          dir: this.state.notescdt.dir,
          page: 0,
        });
        this.handleCloseNoteModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ CASNoteWorking: false });
      }
    } catch (err) {
      // console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ CASNoteWorking: false });
    }
  }

  editNote = (data) => {
    this.setState({
      showNoteModal: true,
      editNoteModal: true,
      ib_cas_note: data.ib_cas_note,
      ib_cas_note_id: data.ib_cas_note_id,
    });
  };

  deleteNote = async (data) => {
    try {
      const res = await GET('cas/delete-note', {
        params: {
          ib_cas_note_id: data.ib_cas_note_id,
        },
      });
      this.setState({
        notescdt: {
          ...this.state.notescdt,
          data: this.state.notescdt.data.filter((item) => item.uid !== data.uid),
        },
      });
      toast.success(t(res.data.message));
    } catch (err) {
      // console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  renderCell = (column_data, column_id, column_index, dataObj) => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;
    const { addReflectionModal } = this.state;

    let tdData;

    // Action Buttons
    if (column_id == 'ib_cas_id') {
      tdData = (
        <>
          {dataObj.visitby_type != 2 && (
            <>
              {/* <Button
                onClick={() => this.delete(dataObj)}
                variant='danger'
                size='sm'
                className='me-1'>
                <FontAwesomeIcon icon={faTrash} />
              </Button> */}
              <Button
                onClick={() => this.edit(dataObj)}
                variant='warning'
                size='sm'
                className='me-1'>
                <FontAwesomeIcon icon={faPencil} />
              </Button>
              <Button
                title='CAS'
                onClick={() => this.CASView(dataObj)}
                variant='success'
                size='sm'
                className='me-1'>
                <FontAwesomeIcon icon={faFileLines} />
              </Button>
            </>
          )}
        </>
      );
    } else if (column_id == 'ib_cas_strands') {
      tdData = JSON.parse(column_data).map((strand, index) => {
        let className = '';
        if (strand === 'Creativity') {
          className = 'badge badge-creativity me-1';
        } else if (strand === 'Activity') {
          className = 'badge badge-activity me-1';
        } else if (strand === 'Service') {
          className = 'badge badge-service me-1';
        }
        return (<span key={index} className={className}>
          {strand}
        </span>)
      });
    } else if (column_id == 'ib_cas_iscasproject') {
      tdData = <Badge bg={column_data == 1 ? 'success' : 'danger'}>{column_data == 1 ? t('YES') : t('NO')}</Badge>
    } else {
      tdData = column_data;
    }

    return <td key={column_index}>{tdData}</td>;
  };

  getTimeline = async () => {
    const { getTimelineData, ib_cas_id } = this.state;
    this.setState({
      getTimelineData: {
        ...this.state.getTimelineData,
        fetching: true,
      },
    });

    if (this.getTimelineReq) {
      this.getTimelineReq.abort();
    }
    this.getTimelineReq = new AbortController();

    try {
      const res = await GET('cas/get-timeline', {
        signal: this.getTimelineReq.signal,
        params: {
          search: getTimelineData.search,
          ib_cas_id
        },
      });

      if (res.status === 200) {
        let uniqueDate = null
        this.setState({
          getTimelineData: {
            ...this.state.getTimelineData,
            fetching: false,
            search: getTimelineData.search,
            data: res.data.map((item) => {
              let uniqueDateFlag = false
              if (!(moment(uniqueDate).isSame(moment(item.date)))) {
                uniqueDateFlag = true
              }
              uniqueDate = moment(item.date).format('YYYY-MM-DD')
              return {
                uid: chance.guid(),
                uniqueDate: uniqueDateFlag ? item.date : null,
                hidden: false,
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      // console.log('err', err);
      this.setState({
        getTimelineData: {
          ...this.state.getTimelineData,
          fetching: false,
        },
      });
    }
  };

  render() {
    let { addReflectionModal, addReflectionForm, cdt, showReflectionModal, getTimelineData } = this.state

    console.log('this.state', this.state);

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('CAS')} backBtn />
            <div>
              <div className='d-flex flex-row align-items-center p-2'>
                <div style={{ flex: 1 }} className='pe-2'>
                  <div className='cdt-search' style={{ border: '#CFD4DA 1px solid', width: '100%', borderRadius: '20px', padding: '8px' }}>
                    <input
                      type='text'
                      defaultValue={this.state.cdt.search}
                      onChange={(e) =>
                        this.fetch({
                          search: e.target.value,
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                          page: 0,
                        })
                      }
                      placeholder={t('Search...')}
                    />
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => this.fetch({
                      search: this.state.cdt.search,
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: (this.state.cdt.dir == 'ASC') ? 'DESC' : 'ASC',
                      page: 0,
                    })}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold' }}
                    className='btn btn-light btn-sm me-2'>
                    <GetIcon icon={'LuArrowDownUp'} className={'me-2'} />
                    {t('SORT')}
                  </button>
                </div>
                <div>
                  <button
                    onClick={() => this.exportExcel()}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold', color: Taurus }}
                    className='btn btn-light btn-sm me-2'>
                    <GetIcon icon={'FaRegFileExcel'} className={'me-2'} />
                    {t('EXCEL')}
                  </button>
                </div>
                <div>
                  <button
                    onClick={this.handleOpenFormModal}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold', color: White }}
                    className='btn btn-primary btn-sm me-2'>
                    <GetIcon icon={'LuPlus'} className={'me-2'} />
                    {t('Add')}
                  </button>
                </div>
              </div>
            </div>
            <div className='grey-section p-3'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                <div style={{ width: '100%', minHeight: '66vh', height: '66vh' }} className='d-flex'>
                  <div style={{ borderRadius: 25, flex: 1 }} className='d-flex flex-column'>
                    {/* TABLE BODY */}
                    <div style={{ flex: 1, overflowY: 'auto' }} className='p-2'>
                      <div style={{ width: '100%' }} className='d-flex flex-row flex-wrap align-items-stretch'>
                        {cdt.data.map((cdt_v, cdt_i) => {
                          let selectedExperience = this.experience_status_options.find((v) => v.value == cdt_v.ib_cas_experience_status)
                          let selectedProgress = this.progress_options.find((v) => v.value == cdt_v.ib_cas_progress)
                          return <div key={cdt_i} className='p-2 mb-2' style={{ width: '33.33%', }}>
                            <div style={{ backgroundColor: Lotion, borderRadius: 10, height: '100%' }} className='p-2 mb-2 d-flex flex-column'>
                              <div style={{ flex: 1, fontSize: 11 }} className='d-flex flex-row align-items-center mb-1'>
                                <GetIcon icon={(cdt_v.ib_cas_iscasproject) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: (cdt_v.ib_cas_iscasproject) ? Taurus : RedLustre, fontSize: 14 }} />
                                <div className='ms-1' style={{ color: SpanishGray }}>{t('CAS Project')}</div>
                              </div>
                              <div style={{ flex: 1, fontWeight: 'bold' }}>{cdt_v.ib_cas_name}</div>

                              {/* <div style={{ flex: 1 }} className='d-flex flex-row align-items-center'>
                                <GetIcon icon={(cdt_v.ib_essay_completed) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: brand_colors[this.props.defaultTheme.theme_id][(cdt_v.ib_essay_completed) ? 'Taurus' : 'RedLustre'], fontSize: 16 }} />
                                <div className='ms-1'>{t('Completed')}</div>
                              </div>
                              <div style={{ flex: 1 }} className='d-flex flex-row align-items-center'>
                                <GetIcon icon={(cdt_v.ib_essay_approved) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: brand_colors[this.props.defaultTheme.theme_id][(cdt_v.ib_essay_approved) ? 'Taurus' : 'RedLustre'], fontSize: 16 }} />
                                <div className='ms-1'>{t('Approved')}</div>
                              </div> */}
                              {(selectedExperience || selectedProgress) &&
                                <div style={{}} className='d-flex flex-row px-1 mt-1'>
                                  {selectedExperience &&
                                    <div className='px-1' style={{ fontSize: 11, fontWeight: 'bold' }}>
                                      <div className='d-flex flex-row align-items-center justify-content-center flex-wrap px-2 py-1' style={{ backgroundColor: selectedExperience?.backgroundColor, color: selectedExperience?.color, width: '100%', height: '100%', borderRadius: 10 }}>
                                        {(cdt_v.ib_cas_experience_status) ? cdt_v.ib_cas_experience_status : 'Select Experince'}
                                      </div>
                                    </div>
                                  }
                                  {selectedProgress &&
                                    <div className='px-1' style={{ fontSize: 11, fontWeight: 'bold' }}>
                                      <div className='d-flex flex-row align-items-center justify-content-center flex-wrap px-2 py-1' style={{ backgroundColor: selectedProgress?.backgroundColor, color: selectedProgress?.color, width: '100%', height: '100%', borderRadius: 10 }}>
                                        {(cdt_v.ib_cas_progress) ? cdt_v.ib_cas_progress : 'Select Progress'}
                                      </div>
                                    </div>
                                  }
                                </div>
                              }

                              <div className='pt-2 d-flex flex-row align-items-center'>
                                <div style={{ width: '50%' }} className='px-1'>
                                  <Button variant='warning' size='sm' onClick={() => this.edit(cdt_v)} style={{ width: '100%' }} >
                                    <GetIcon icon={'LuPencil'} style={{ fontSize: 16 }} />
                                  </Button>
                                </div>
                                <div style={{ width: '50%' }} className='px-1'>
                                  <Button variant='outline-primary' size='sm' onClick={() => this.CASView(cdt_v)} disabled={(cdt_v.visitby_type == 2) ? true : false} style={{ width: '100%' }} >
                                    <GetIcon icon={'LuFile'} style={{ fontSize: 16 }} />
                                  </Button>
                                </div>
                              </div>

                            </div>
                          </div>
                        })}
                      </div>
                    </div>
                    {/* PAGINATION */}
                    <div className='d-flex justify-content-center align-items-center' style={{ borderTop: 'solid 1px ' + Concrete }}>
                      <Pagination
                        pageCount={this.state.cdt.lastPage || 1}
                        forcePage={this.state.cdt.page}
                        callbackParams={{
                          search: this.state.cdt.search,
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                        }}
                        callback={this.fetch}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FORM MODAL */}
        <Modal
          backdrop='static'
          keyboard={false}
          size={'xxl'}
          show={this.state.showFormModal}
          onHide={this.handleCloseFormModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.isEditing ? t('Edit') : t('Add')} {t('CAS')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Row>
                  <Col md={8}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Experience Name')} <span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        type='text'
                        defaultValue={this.state.ib_cas_name}
                        onChange={(e) =>
                          this.setState({ ib_cas_name: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} style={{ paddingTop: 38 }}>
                    <Form.Check
                      type="switch"
                      label={t('CAS Project')}
                      id="ib_cas_iscasproject"
                      checked={this.state.ib_cas_iscasproject == 1}
                      onChange={(e) => this.setState({ ib_cas_iscasproject: this.state.ib_cas_iscasproject == 0 ? 1 : 0 })}
                    />
                  </Col>
                  <Col md={12} className='mb-3'>
                    <Form.Label>{t('Approaches')}</Form.Label>
                    <Row>
                      <Col md={5} className="mb-1">
                        <Form.Check
                          type="checkbox"
                          label={t('Ongoing')}
                          value="Ongoing"
                          onChange={(e) => this.handleCheckbox(e, 'ib_cas_approaches')}
                          checked={this.state.ib_cas_approaches.includes('Ongoing')}
                        />
                      </Col>
                      <Col md={6} className="mb-1">
                        <Form.Check
                          type="checkbox"
                          label={t('School-based')}
                          value="School-based"
                          onChange={(e) => this.handleCheckbox(e, 'ib_cas_approaches')}
                          checked={this.state.ib_cas_approaches.includes('School-based')}
                        />
                      </Col>
                      <Col md={5} className="mb-1">
                        <Form.Check
                          type="checkbox"
                          label={t('Community-based')}
                          value="Community-based"
                          onChange={(e) => this.handleCheckbox(e, 'ib_cas_approaches')}
                          checked={this.state.ib_cas_approaches.includes('Community-based')}
                        />
                      </Col>
                      <Col md={6} className="mb-1">
                        <Form.Check
                          type="checkbox"
                          label={t('Individual')}
                          value="Individual"
                          onChange={(e) => this.handleCheckbox(e, 'ib_cas_approaches')}
                          checked={this.state.ib_cas_approaches.includes('Individual')}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Label>{t('Start Date')}</Form.Label>
                    <DatePicker
                      selected={this.state.ib_cas_startdate}
                      onChange={(date) =>
                        this.setState({ ib_cas_startdate: date })
                      }
                      selectsStart
                      dateFormat={'dd-MM-yyyy'}
                    />
                  </Col>
                  <Col md={6} className='mb-3'>
                    <Form.Label>{t('End Date')}</Form.Label>
                    <DatePicker
                      selected={this.state.ib_cas_enddate}
                      onChange={(date) =>
                        this.setState({ ib_cas_enddate: date })
                      }
                      selectsStart
                      dateFormat={'dd-MM-yyyy'}
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label>{t('Description & Goals')}</Form.Label>
                    <Form.Control defaultValue={this.state.ib_cas_description} onChange={(e) => this.setState({ ib_cas_description: e.target.value })}
                      as="textarea" rows={3} />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Col md={12} className='mb-3'>
                  <Form.Label>{t('Strands')}</Form.Label>
                  <div>
                    <button
                      className={`btn-strand btn-creativity ${this.state.ib_cas_strands.includes('Creativity') ? 'active' : ''}`}
                      onClick={() => this.handleStrandClick('Creativity')}
                    >
                      <span>C</span>{t('Creativity')}
                    </button>
                    <button
                      className={`btn-strand btn-activity ${this.state.ib_cas_strands.includes('Activity') ? 'active' : ''}`}
                      onClick={() => this.handleStrandClick('Activity')}
                    >
                      <span>A</span>{t('Activity')}
                    </button>
                    <button
                      className={`btn-strand btn-service ${this.state.ib_cas_strands.includes('Service') ? 'active' : ''}`}
                      onClick={() => this.handleStrandClick('Service')}
                    >
                      <span>S</span>{t('Service')}
                    </button>
                  </div>
                </Col>
                <Col md={12} className='mb-3'>
                  <Form.Label>{t('Type of Service Action')}</Form.Label>
                  <Row>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        disabled={!this.state.ib_cas_strands.includes('Service')}
                        type={'radio'}
                        label={t('Direct')}
                        name='ib_cas_service_actions'
                        value={'Direct'}
                        onChange={(e) => this.setState({ ib_cas_service_actions: e.target.value })}
                        checked={this.state.ib_cas_service_actions == 'Direct'}
                      />
                    </Col>
                    <Col md={6} className='mb-1'>
                      <Form.Check
                        disabled={!this.state.ib_cas_strands.includes('Service')}
                        type={'radio'}
                        label={t('Indirect')}
                        name='ib_cas_service_actions'
                        value={'Indirect'}
                        onChange={(e) => this.setState({ ib_cas_service_actions: e.target.value })}
                        checked={this.state.ib_cas_service_actions == 'Indirect'}
                      />
                    </Col>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        disabled={!this.state.ib_cas_strands.includes('Service')}
                        type={'radio'}
                        label={t('Advocacy')}
                        name='ib_cas_service_actions'
                        value={'Advocacy'}
                        onChange={(e) => this.setState({ ib_cas_service_actions: e.target.value })}
                        checked={this.state.ib_cas_service_actions == 'Advocacy'}
                      />
                    </Col>
                    <Col md={6} className='mb-1'>
                      <Form.Check
                        disabled={!this.state.ib_cas_strands.includes('Service')}
                        type={'radio'}
                        label={t('Research')}
                        name='ib_cas_service_actions'
                        value={'Research'}
                        onChange={(e) => this.setState({ ib_cas_service_actions: e.target.value })}
                        checked={this.state.ib_cas_service_actions == 'Research'}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Supervisors')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isMulti
                      closeMenuOnSelect={false}
                      options={this.state.supervisors}
                      onChange={(event) => this.setState({ ib_cas_supervisors: event })}
                      value={this.state.ib_cas_supervisors}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Label>{t('Please select your targeted learning outcomes:')}</Form.Label>
                  <Row>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Strength & Growth')}
                        value={'Strength & Growth'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Strength & Growth')}
                      />
                    </Col>
                    <Col md={6} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Challenge & Skills')}
                        value={'Challenge & Skills'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Challenge & Skills')}
                      />
                    </Col>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Initiative & Planning')}
                        value={'Initiative & Planning'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Initiative & Planning')}
                      />
                    </Col>
                    <Col md={6} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Commitment & Perseverance')}
                        value={'Commitment & Perseverance'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Commitment & Perseverance')}
                      />
                    </Col>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Collaborative Skills')}
                        value={'Collaborative Skills'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Collaborative Skills')}
                      />
                    </Col>
                    <Col md={6} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Global Engagement')}
                        value={'Global Engagement'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Global Engagement')}
                      />
                    </Col>
                    <Col md={5} className='mb-1'>
                      <Form.Check
                        type={'checkbox'}
                        label={t('Ethics of Choices & Actions')}
                        value={'Ethics of Choices & Actions'}
                        onChange={(e) => this.handleCheckbox(e, 'ib_cas_target_outcome')}
                        checked={this.state.ib_cas_target_outcome.includes('Ethics of Choices & Actions')}
                      />
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseFormModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant='success'
              onClick={() => this.saveUpdate()}>
              {t('Save')}{' '}
              {this.state.working ? (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                ''
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* CAS VIEW MODAL */}
        <Modal
          backdrop='static'
          keyboard={false}
          fullscreen
          show={this.state.showReflectionModal.show}
          onHide={this.handleCloseReflectionListModal}>
          <Modal.Header closeButton>
            <div className='w-100 d-flex flex-row justify-content-between'>
              <div style={{ flex: 1 }}>
                <Modal.Title style={{ fontSize: 20 }}>
                  {this.state.ib_cas_name}
                  <GetIcon icon={'FaCircle'} className={'mx-2'} style={{ fontSize: 8, color: SoftGray }} />
                  {this.props.selectedChild.child_name}
                </Modal.Title>
              </div>
              <div className='d-flex flex-column justify-content-center align-items-end' style={{ flex: 1 }}>
                <ButtonGroup size='sm'>
                  <Button variant={(showReflectionModal.viewStyle == 'tab') ? 'primary' : 'light'} onClick={() => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, viewStyle: 'tab' }, })}>
                    <GetIcon icon="LuColumns2" className={'me-1'} />
                    Tab View
                  </Button>
                  <Button variant={(showReflectionModal.viewStyle == 'timeline') ? 'primary' : 'light'} onClick={() => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, viewStyle: 'timeline' }, }, () => this.getTimeline())}>
                    <GetIcon icon="LuText" className={'me-1'} />
                    Timeline View
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className='p-0'>
            <div className='d-flex flex-row' style={{ fontSize: 12 }}>
              {/* LEFT */}
              <div style={{ width: '30%', minHeight: '85vh', height: '85vh', overflowY: 'auto' }} className='d-flex'>
                <div style={{ backgroundColor: White, flex: 1 }} className='d-flex flex-column p-3'>
                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>{t('Experience Name')}</div>
                    <div>{this.state.ib_cas_name}</div>
                    {this.state.ib_cas_iscasproject == 1 &&
                      <Badge bg='success'><FontAwesomeIcon icon={faCheck} /> {t('CAS Project')}</Badge>
                    }
                  </div>
                  <div className='mb-3 d-flex flex-row justify-content-between'>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{t('Start Date')}</div>
                      <div> {(this.state.ib_cas_startdate) ? moment(this.state.ib_cas_startdate).format('DD-MM-YYYY') : null}</div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{t('End Date')}</div>
                      <div> {(this.state.ib_cas_enddate) ? moment(this.state.ib_cas_enddate).format('DD-MM-YYYY') : null}</div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>{t('Description & Goals')}</div>
                    <div>{this.state.ib_cas_description}</div>
                  </div>

                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>{t('CAS')}</div>
                    <div>
                      {this.state.ib_cas_strands.map((strand, index) => {
                        let className = '';
                        if (strand === 'Creativity') {
                          className = 'badge badge-creativity me-1';
                        } else if (strand === 'Activity') {
                          className = 'badge badge-activity me-1';
                        } else if (strand === 'Service') {
                          className = 'badge badge-service me-1';
                        }
                        return (<span key={index} className={className}>
                          {strand}
                        </span>)
                      })}
                    </div>
                  </div>
                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>{t('Type of Service Action')}</div>
                    <div>{this.state.ib_cas_service_actions}</div>
                  </div>
                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>{t('Targeted Learning Outcomes')}</div>
                    <div>{this.state.ib_cas_target_outcome.join(', ')}</div>
                  </div>
                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>Experience Status</div>
                    {this.state.ib_cas_experience_status &&
                      <div className='px-1' style={{ fontSize: 11, fontWeight: 'bold' }}>
                        <div className='d-flex flex-row align-items-center justify-content-center flex-wrap px-2 py-1' style={{ backgroundColor: this.state.ib_cas_experience_status?.backgroundColor, color: this.state.ib_cas_experience_status?.color, width: '100%', height: '100%', borderRadius: 10 }}>
                          {this.state.ib_cas_experience_status.label}
                        </div>
                      </div>
                    }
                  </div>

                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>Progress</div>
                    {this.state.ib_cas_progress &&
                      <div className='px-1' style={{ fontSize: 11, fontWeight: 'bold' }}>
                        <div className='d-flex flex-row align-items-center justify-content-center flex-wrap px-2 py-1' style={{ backgroundColor: this.state.ib_cas_progress?.backgroundColor, color: this.state.ib_cas_progress?.color, width: '100%', height: '100%', borderRadius: 10 }}>
                          {this.state.ib_cas_progress.label}
                        </div>
                      </div>
                    }
                  </div>

                  <div className='mb-3'>
                    <div style={{ fontWeight: 'bold' }}>Supervisors</div>
                    <div className='d-flex flex-row flex-wrap'>
                      {this.state.supervisors.map((v) =>
                        <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center me-1 mb-1'>
                          {v.label}
                        </div>
                      )}
                    </div>
                  </div>


                </div>
              </div>
              {/* RIGHT */}
              <div style={{ width: '70%', minHeight: '85vh', height: '85vh' }} className='d-flex position-relative'>
                <div className='grey-section p-3 m-0' style={{ flex: 1, borderRadius: 0, overflowY: 'auto' }}>
                  {/* TAB */}
                  {(showReflectionModal.viewStyle == 'tab') &&
                    <div className='' style={{ height: '100%' }}>

                      <Tab.Container defaultActiveKey={this.state.activeTab} style={{ flex: 1 }} onSelect={(activeTab) => this.setState({
                        activeTab
                      })}>
                        <div className='d-flex flex-column' style={{ height: '100%' }}>
                          <div className="d-flex flex-row align-items-start" style={{ height: '8%' }}>
                            <Nav className="d-flex flex-row flex-wrap" style={{ flex: 1 }}>
                              <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0
                              }}>
                                <Nav.Item>
                                  <Nav.Link eventKey="documents">DOCUMENTS</Nav.Link>
                                </Nav.Item>
                              </Button>
                              <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0
                              }}>
                                <Nav.Item>
                                  <Nav.Link eventKey="reflections">REFELCTIONS</Nav.Link>
                                </Nav.Item>
                              </Button>
                              <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0
                              }}>
                                <Nav.Item>
                                  <Nav.Link eventKey="notes">NOTES</Nav.Link>
                                </Nav.Item>
                              </Button>
                              <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0
                              }}>
                                <Nav.Item>
                                  <Nav.Link eventKey="supervisor-review">SUPERVISOR REVIEW</Nav.Link>
                                </Nav.Item>
                              </Button>
                            </Nav>
                            <div>
                              {this.state.activeTab == 'documents' &&
                                <Button
                                  onClick={() => this.setState({ showDocumentModal: true })}
                                  variant='success'
                                  size='sm'>
                                  <FontAwesomeIcon icon={faPlus} /> {t('Document')}
                                </Button>
                              }

                              {this.state.activeTab == 'reflections' &&
                                <Button
                                  onClick={() => addReflectionModal.toggle({ ...this.defaultReflectionFields, ib_cas_id: this.state.ib_cas_id, details: [] }, false)}
                                  variant='success'
                                  size='sm'>
                                  <FontAwesomeIcon icon={faPlus} /> {t('Reflection')}
                                </Button>
                              }
                              {this.state.activeTab == 'notes' &&
                                <Button
                                  onClick={() => this.setState({ showNoteModal: true })}
                                  variant='success'
                                  size='sm'>
                                  <FontAwesomeIcon icon={faPlus} /> {t('Note')}
                                </Button>
                              }
                            </div>
                          </div>
                          <Tab.Content style={{ height: '92%', backgroundColor: White, borderRadius: 5, }}>

                            <Tab.Pane eventKey="documents" style={{ height: '100%' }}>
                              <div style={{ height: '85%', overflowY: 'auto' }}>
                                {this.state.docscdt.fetching && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    <Spinner as='span' animation='grow' size='sm' />{' '}
                                    {t('Loading Data')}
                                  </div>
                                )}
                                {!this.state.docscdt.fetching && this.state.docscdt.data.length === 0 && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    {t('No Data Found')}
                                  </div>
                                )}

                                {!this.state.docscdt.fetching && this.state.docscdt.data.length !== 0 && this.state.docscdt.data.map((item, index) => (
                                  <div className='p-2 mb-2 d-flex flex-row justify-content-between align-items-center' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                    <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                      <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                        <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                        {moment(item.ib_cas_doc_date).format('DD-MM-YYYY')}
                                      </div>
                                      <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-1'>
                                        <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                        {item.created_by_name}
                                      </div>
                                      <Button variant='link' className='ms-2 p-0' onClick={() => {
                                        let url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_documents/' + item.ib_cas_doc_name;
                                        window.open(url, '_blank');
                                      }}>
                                        {item.ib_cas_doc_caption}
                                      </Button>
                                    </div>
                                    <div className='d-flex flex-row align-items-center'>
                                      {item.created_by == this.props.authData.loginData.user_id &&
                                        <Button variant='warning' className='me-1'
                                          onClick={() => this.editDoc(item)}
                                          size='sm'>
                                          <FontAwesomeIcon icon={faPencil} />
                                        </Button>
                                      }
                                      {item.created_by == this.props.authData.loginData.user_id &&
                                        <Button variant='danger'
                                          onClick={() => this.deleteDoc(item)}
                                          size='sm'>
                                          <FontAwesomeIcon icon={faTrash} />
                                        </Button>
                                      }
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                <Pagination
                                  pageCount={this.state.docscdt.lastPage || 1}
                                  forcePage={this.state.docscdt.page}
                                  callbackParams={{
                                    search: this.state.docscdt.search,
                                    limit: this.state.docscdt.rows,
                                    order: this.state.docscdt.order,
                                    dir: this.state.docscdt.dir,
                                  }}
                                  callback={this.getDocs}
                                />
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="reflections" style={{ height: '100%' }}>
                              <div style={{ height: '85%', overflowY: 'auto' }}>
                                {this.state.refcdt.fetching && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    <Spinner as='span' animation='grow' size='sm' />{' '}
                                    {t('Loading Data')}
                                  </div>
                                )}
                                {!this.state.refcdt.fetching && this.state.refcdt.data.length === 0 && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    {t('No Data Found')}
                                  </div>
                                )}

                                {!this.state.refcdt.fetching && this.state.refcdt.data.length !== 0 && this.state.refcdt.data.map((item, index) => (
                                  <div className='p-2 mb-2 d-flex flex-column' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                    <div className='d-flex flex-row justify-content-between align-items-center'>
                                      <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                        {item.ib_cas_ref_date &&
                                          <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                            <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {moment(item.ib_cas_ref_date).format('DD-MM-YYYY')}
                                          </div>
                                        }
                                        <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-2'>
                                          <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {item.created_by_name}
                                        </div>
                                        <div className='mx-2' style={{ fontWeight: 'bold' }}>{item.ib_cas_ref_title}</div>
                                      </div>
                                      <div>
                                        {item.ib_cas_ref_approved == 1 &&
                                          <Badge bg='success' className='me-2'><FontAwesomeIcon icon={faCheck} /> {t('Approved')}</Badge>
                                        }
                                        {[this.props.selectedChild.child_user_id, this.props.authData.loginData.user_id].includes(item.created_by) &&
                                          <Button variant='warning' className='me-2'
                                            onClick={() => this.editReflection({ ...item })}
                                            size='sm'>
                                            <FontAwesomeIcon icon={faPencil} />
                                          </Button>
                                        }
                                      </div>
                                    </div>
                                    <div className='my-1'>
                                      <div dangerouslySetInnerHTML={{ __html: item.ib_cas_ref_desc }} />
                                    </div>
                                    {item.ib_cas_ref_target_outcome &&
                                      <div className='mb-2'>
                                        {JSON.parse(item.ib_cas_ref_target_outcome).map((item, index) => <Badge key={index} bg='warning' className='me-2'>{item}</Badge>)}
                                      </div>
                                    }
                                    <div>
                                      {item.reflection_details.map((item, index) => {
                                        let icon = null;
                                        let url = null;

                                        if (item.ib_cas_refd_type == 'URL') {
                                          icon = faGlobe;
                                          url = makeURL(item.ib_cas_refd_value)
                                        } else if (item.ib_cas_refd_type == 'Image') {
                                          icon = faImage;
                                          url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + item.ib_cas_refd_value;
                                        } else if (item.ib_cas_refd_type == 'File') {
                                          icon = faFolder;
                                          url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + item.ib_cas_refd_value;
                                        }

                                        const name = item.ib_cas_refd_name ? item.ib_cas_refd_name : item.ib_cas_refd_type;

                                        return (<div style={{ display: 'inline-block', position: 'relative' }} key={index}>
                                          {item.created_by == this.props.authData.loginData.user_id &&
                                            <Button variant='danger' size="sm" style={{ width: 20, height: 20, borderRadius: 10, padding: 0, lineHeight: '10px', position: 'absolute', top: -7, right: 5 }} onClick={() => this.setState({ deleteModal: { show: true, id: item.ib_cas_refd_id, action: this.delRefDetail } })}>
                                              <FontAwesomeIcon icon={faTrashCan} style={{ fontSize: 10 }} />
                                            </Button>
                                          }
                                          <Button
                                            onClick={() => {
                                              window.open(url, '_blank');
                                            }}
                                            key={index}
                                            variant='outline-dark'
                                            size='sm'
                                            className='me-3'>
                                            <FontAwesomeIcon icon={icon} /> {name}
                                          </Button>
                                        </div>)
                                      })}
                                    </div>

                                  </div>
                                ))}
                              </div>
                              <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                <Pagination
                                  pageCount={this.state.refcdt.lastPage || 1}
                                  forcePage={this.state.refcdt.page}
                                  callbackParams={{
                                    search: this.state.refcdt.search,
                                    limit: this.state.refcdt.rows,
                                    order: this.state.refcdt.order,
                                    dir: this.state.refcdt.dir,
                                  }}
                                  callback={this.getReflections}
                                />
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="notes" style={{ height: '100%' }}>
                              <div style={{ height: '85%', overflowY: 'auto' }}>
                                {this.state.notescdt.fetching && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    <Spinner as='span' animation='grow' size='sm' />{' '}
                                    {t('Loading Data')}
                                  </div>
                                )}
                                {!this.state.notescdt.fetching && this.state.notescdt.data.length === 0 && (
                                  <div
                                    className='py-5 d-flex flex-column align-items-center'>
                                    {t('No Data Found')}
                                  </div>
                                )}

                                {!this.state.notescdt.fetching && this.state.notescdt.data.length !== 0 && this.state.notescdt.data.map((item, index) => (
                                  <div className='p-2 mb-2 d-flex flex-column ' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                    <div className='d-flex flex-row justify-content-between align-items-center mb-1'>
                                      <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                        <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                          <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {moment(item.ib_cas_doc_date).format('DD-MM-YYYY')}
                                        </div>
                                        <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-1'>
                                          <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {item.created_by_name}
                                        </div>
                                      </div>
                                      <div className='d-flex flex-row align-items-center'>
                                        {item.created_by == this.props.authData.loginData.user_id &&
                                          <Button variant='warning' className='me-1'
                                            onClick={() => this.editNote(item)}
                                            size='sm'>
                                            <FontAwesomeIcon icon={faPencil} />
                                          </Button>
                                        }
                                        {item.created_by == this.props.authData.loginData.user_id &&
                                          <Button variant='danger'
                                            onClick={() => this.deleteNote(item)}
                                            size='sm'>
                                            <FontAwesomeIcon icon={faTrash} />
                                          </Button>
                                        }
                                      </div>
                                    </div>
                                    <div>{item.ib_cas_note}</div>
                                  </div>
                                ))}
                              </div>
                              <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                <Pagination
                                  pageCount={this.state.notescdt.lastPage || 1}
                                  forcePage={this.state.notescdt.page}
                                  callbackParams={{
                                    search: this.state.notescdt.search,
                                    limit: this.state.notescdt.rows,
                                    order: this.state.notescdt.order,
                                    dir: this.state.notescdt.dir,
                                  }}
                                  callback={this.getNotes}
                                />
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="supervisor-review" style={{ height: '100%' }}>
                              <div style={{ height: '100%', overflowY: 'auto' }}>
                                {(this.state.ib_cas_supervisor_review) &&
                                  <div dangerouslySetInnerHTML={{ __html: this.state.ib_cas_supervisor_review }} />
                                }
                              </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </div>
                      </Tab.Container>


                    </div>
                  }
                  {(showReflectionModal.viewStyle == 'timeline') &&
                    <div className='d-flex flex-column'>
                      {/* TIME CARD START */}
                      {getTimelineData.data.map((getTimelineData_v, getTimelineData_i) => {
                        return <div className='d-flex flex-row mb-2'>
                          <div style={{ flex: 1 }} className='d-flex flex-row justify-content-end align-items-start'>
                            {/* DATE */}
                            <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5, position: 'sticky', top: 0, opacity: (getTimelineData_v.uniqueDate) ? 1 : 0.3 }} className='d-flex flex-row align-items-center'>
                              <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                              {moment(getTimelineData_v.date).format('DD-MM-YYYY')}
                            </div>
                          </div>
                          {/* TIMELINE CARD */}
                          <div className='d-flex flex-column justify-content-center px-2' style={{ flex: 2.5, opacity: (getTimelineData_v.hidden) ? 0.3 : 1 }}>
                            <div className='p-2 d-flex flex-column' style={{ backgroundColor: White, borderRadius: 5 }}>
                              <div className='d-flex flex-row justify-content-between'>
                                <div className='d-flex flex-row justify-content-between'>
                                  {getTimelineData_v.created_by_name &&
                                    <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center me-1'>
                                      <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                      {getTimelineData_v.created_by_name}
                                    </div>

                                  }
                                  <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                    <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                    {getTimelineData_v.typeName}
                                  </div>
                                </div>
                              </div>
                              {getTimelineData_v.title &&
                                <div style={{ fontWeight: 'bold' }} className='mt-2'>{getTimelineData_v.title}</div>
                              }
                              {getTimelineData_v.description &&
                                <div className='mt-1' dangerouslySetInnerHTML={{ __html: getTimelineData_v.description }} />
                              }

                              {getTimelineData_v?.attachment &&
                                <div>
                                  <div className='mt-1 me-3' style={{ display: 'inline-block', position: 'relative' }} >
                                    <Button
                                      onClick={() => {
                                        window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/' + getTimelineData_v.type + '/' + getTimelineData_v.attachment, '_blank');
                                      }}
                                      variant='outline-dark'
                                      size='sm'
                                    >
                                      <FontAwesomeIcon icon={faFolder} /> {'File'}
                                    </Button>
                                  </div>
                                </div>
                              }
                              {getTimelineData_v?.reflection_details &&
                                <div >
                                  {getTimelineData_v?.reflection_details.map((item, index) => {
                                    let icon = null;
                                    let url = null;

                                    if (item.ib_cas_refd_type == 'URL') {
                                      icon = faGlobe;
                                      url = makeURL(item.ib_cas_refd_value)
                                    } else if (item.ib_cas_refd_type == 'Image') {
                                      icon = faImage;
                                      url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + item.ib_cas_refd_value;
                                    } else if (item.ib_cas_refd_type == 'File') {
                                      icon = faFolder;
                                      url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + item.ib_cas_refd_value;
                                    }

                                    const name = item.ib_cas_refd_name ? item.ib_cas_refd_name : item.ib_cas_refd_type;

                                    return (<div className='mt-1 me-3' style={{ display: 'inline-block', position: 'relative' }} key={index}>
                                      <Button
                                        onClick={() => {
                                          window.open(url, '_blank');
                                        }}
                                        key={index}
                                        variant='outline-dark'
                                        size='sm'
                                      >
                                        <FontAwesomeIcon icon={icon} /> {name}
                                      </Button>
                                    </div>)
                                  })}
                                </div>
                              }
                            </div>
                          </div>
                          <div style={{ flex: 1 }} className='d-flex flex-row justify-content-start align-items-start'>
                            {/* PRINT HIDDEN */}
                            <div style={{ padding: '5px 10px', }} className='d-flex flex-row align-items-center'>
                              <div className='cursor-pointer' onClick={() => {
                                getTimelineData.data[getTimelineData_i].hidden = !getTimelineData.data[getTimelineData_i].hidden
                                this.setState({ getTimelineData })
                              }}>
                                <GetIcon icon={(getTimelineData_v.hidden) ? 'LuEyeOff' : 'LuEye'} style={{ fontSize: 20, color: NewGray }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      })}
                    </div>
                  }
                  {(showReflectionModal.viewStyle == 'timeline') &&
                    <div style={{ position: 'absolute', bottom: 30, right: 15 }}>
                      <Button variant='light' size='sm' style={{ fontSize: 12 }}>
                        <GetIcon icon={'LuPrinter'} className={'me-1'} style={{ fontSize: 15 }} />
                        PRINT
                      </Button>
                    </div>
                  }

                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* REFLECTION MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} size={'lg'} show={addReflectionModal.show} onHide={addReflectionModal.toggle}>
          <Modal.Header closeButton>
            <Modal.Title>
              {addReflectionModal.isEditing ? t('Edit') : t('Add')} {t('Reflection')}
            </Modal.Title>
          </Modal.Header>
          {addReflectionModal.show &&
            <Modal.Body>
              <Row>
                <Col md={8}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Title')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type='text'
                      defaultValue={addReflectionForm.ib_cas_ref_title}
                      onChange={(e) =>
                        this.setReflectionValue('ib_cas_ref_title', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Date')}</Form.Label>
                    <DatePicker
                      selected={addReflectionForm.ib_cas_ref_date}
                      onChange={(date) =>
                        this.setReflectionValue('ib_cas_ref_date', date)
                      }
                      selectsStart
                      dateFormat={'dd-MM-yyyy'}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className='ck-editor-ht-200'>
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col> <Form.Label>{t('Notes')}</Form.Label></Col>
                    </Row>
                    <CKEditor
                      config={{
                        removePlugins: ['Title'],
                        toolbar: {
                          items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'alignment',
                            '|',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'undo',
                            'redo'
                          ]
                        }
                      }}
                      editor={Editor}
                      data={addReflectionForm.ib_cas_ref_desc}
                      onChange={(
                        event,
                        editor
                      ) => {
                        const ib_cas_ref_desc = editor.getData();
                        this.setReflectionValue('ib_cas_ref_desc', ib_cas_ref_desc);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className='mb-3'>
                  <Form.Label>{t('Please select your targeted learning outcomes:')}</Form.Label>
                  <Row>
                    {this.state.ib_cas_target_outcome.map((item, index) => (
                      <Col key={index} md={5} className='mb-1'>
                        <Form.Check
                          type={'checkbox'}
                          label={t(item)}
                          value={item}
                          onChange={this.handleReflectionOutcomeCheckbox}
                          checked={addReflectionForm.ib_cas_ref_target_outcome?.includes(item)}
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
              {/* {!addReflectionModal.isEditing && */}
              <Row>
                <Col className='d-flex flex-row'>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('URL')}>Add URL</Button>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('Image')}>Add Image</Button>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('File')}>Add File</Button>
                </Col>
              </Row>
              {/* } */}
              <Row>
                {addReflectionForm.details.map((v, i) => {
                  return <Col key={i} md="6">
                    <div className='border p-1 m-1'>
                      <Form.Group className='mb-3'>
                        <div className='badge badge-light-danger me-1'>{t('Reflection')}{' ' + (i + 1) + ':'}</div>
                        <Form.Label>
                          {t('Title')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={v.ib_cas_refd_name}
                          onChange={(e) =>
                            this.setReflectionDetailValue(i, 'ib_cas_refd_name', e.target.value)
                          }
                        />
                      </Form.Group>
                      {(v.ib_cas_refd_type == 'URL') &&
                        <Form.Group className='mb-3'>
                          <Form.Label>{t('URL')}</Form.Label>
                          <Form.Control
                            type='text'
                            defaultValue={v.ib_cas_refd_value}
                            onChange={(e) =>
                              this.setReflectionDetailValue(i, 'ib_cas_refd_value', e.target.value)
                            }
                          />
                        </Form.Group>
                      }
                      {(v.ib_cas_refd_type == 'Image' || v.ib_cas_refd_type == 'File') &&
                        <Form.Group controlId='formFile'>
                          <Form.Label>
                            {v.ib_cas_refd_type + ' ' + t('Attachment')}
                          </Form.Label>
                          <Form.Control
                            type='file'
                            onChange={(e) => this.setReflectionDetailValue(i, 'ib_cas_refd_value', e.target.files[0])}
                          />
                        </Form.Group>
                      }
                      {(v.ib_cas_refd_type == 'Image' && v.ib_cas_refd_value && (typeof v.ib_cas_refd_value == 'string')) && (
                        <div className='pic-prev d-flex justify-content-center'>
                          <img
                            alt=''
                            style={{ maxWidth: 270, height: '100%', }}
                            src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + v.ib_cas_refd_value}
                          />
                        </div>
                      )}
                      {(v.ib_cas_refd_type == 'File' && v.ib_cas_refd_value && (typeof v.ib_cas_refd_value == 'string')) && (
                        <div className='pic-prev d-flex justify-content-center'>
                          <a href={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_cas_reflection_details/' + v.ib_cas_refd_value} target='_blank'>Open File</a>
                        </div>
                      )}
                    </div>
                  </Col>
                })}
              </Row>
            </Modal.Body>
          }
          <Modal.Footer>
            <Button variant='secondary' onClick={addReflectionModal.toggle}>
              {t('Close')}
            </Button>
            <Button
              disabled={addReflectionModal.working}
              variant={addReflectionModal.isEditing ? 'warning' : 'success'}
              onClick={() => this.saveUpdateReflection()}>
              {addReflectionModal.isEditing ? t('Update') : t('Save')}{' '}
              {addReflectionModal.working && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* DOCUMENT MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} show={this.state.showDocumentModal} onHide={this.handleCloseDocumentModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.editDocumentModal ? t('Edit') : t('Add')} {t('Document')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId='formFile'>
              <Row>
                <Col>
                  <Form.Control
                    className='mb-3'
                    placeholder={t('Caption')}
                    type='text'
                    value={this.state.ib_cas_doc_caption}
                    onChange={(e) => this.setState({ ib_cas_doc_caption: e.target.value })}
                  />
                </Col>
                <Col>
                  <DatePicker
                    selected={this.state.ib_cas_doc_date}
                    onChange={(date) =>
                      this.setState({ ib_cas_doc_date: date })
                    }
                    selectsStart
                    dateFormat={'dd-MM-yyyy'}
                  />
                </Col>
              </Row>
              {!this.state.editDocumentModal &&
                <>
                  <Form.Control
                    ref={this.docRef}
                    type='file'
                    onChange={(e) => {
                      const selectedFile = e.target.files[0];
                      if (selectedFile.size > 10 * 1024 * 1024) {
                        toast.error(t('Allowed file size is 10MB!'));
                        this.docRef.current.value = '';
                        return;
                      }
                      this.setState({ ib_cas_doc_name: selectedFile })
                    }}
                  />
                  <div className='text-end'>
                    <small className='text-danger'>{t('Allowed file size:')} <strong>10MB</strong></small>
                  </div>
                </>
              }
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseDocumentModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.CASDocWorking}
              variant={'success'}
              onClick={() => this.saveUpdateCASDoc()}>
              {t('Save')}{' '}
              {this.state.CASDocWorking && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* NOTE MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} show={this.state.showNoteModal} onHide={this.handleCloseNoteModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.editNoteModal ? t('Edit') : t('Add')} {t('Note')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId='formFile'>
              <Form.Control
                className='mb-3'
                placeholder={t('Note')}
                as="textarea" rows={3}
                value={this.state.ib_cas_note}
                onChange={(e) => this.setState({ ib_cas_note: e.target.value })}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseNoteModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.CASNoteWorking}
              variant={'success'}
              onClick={() => this.saveUpdateCASNote()}>
              {t('Save')}{' '}
              {this.state.CASNoteWorking && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* CONFIRM DELETE REFLECTION DELETE */}
        <SweetAlert show={this.state.deleteRefDetailConfirm.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.delRefDetail} onCancel={() => this.setState({ deleteRefDetailConfirm: { show: false, id: 0 } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>

      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  selectedChild: state.selectedChild.data
});

export default connect(mapStateToProps, null)(CAS);
